import { io } from 'socket.io-client';

//const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002';
const SOCKET_URL = 'http://localhost:5002';
// シングルトンでインスタンス化
const socket = io(SOCKET_URL);

export default socket;